module.exports = __webpack_public_path__ + "files/d683fe38bb4ac3b68b2710aa5bcea599.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-bolditalic-webfont.woff
 ** module id = 990
 ** module chunks = 0
 **/